import { useState } from "react";
import Modal from "../../../../../components/common/Modal";
import moment from "moment";
import DateStartedForm from "./DateStartedForm";

const DateStarted = ({ data, setData }) => {
  const [showForm, setShowForm] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleSuccess = (item) => {
    const account = { ...data };
    account["started_on"] = item;

    setData(account);
    setShowForm(false);
  };

  return (
    <div className="bg-gray-50 px-6 py-5 grid grid-cols-3">
      <dt className="col-span-2">
        <p className="text-gray-400 text-sm">Date Started</p>
      </dt>
      <dd className="col-span-1 text-blue-400 text-sm cursor-pointer">
        <span className="float-right" onClick={() => setShowForm(true)}>
          Edit
        </span>
      </dd>
      <dt className="col-span-3">
        <p className="text-sm text-gray-500">
          {data.started_on
            ? moment(data.started_on).format("LL")
            : "Not available"}
        </p>
      </dt>
      <Modal
        title="Edit Date Started"
        isOpen={showForm}
        isLoading={isLoading}
        onClose={() => setShowForm(false)}
        borderTop
      >
        <DateStartedForm
          data={data}
          isLoading={isLoading}
          setLoading={setIsLoading}
          onSuccess={handleSuccess}
        />
      </Modal>
    </div>
  );
};

export default DateStarted;
